const matchesCondition = (condition, answersMap) => {
  if (!condition) return true

  // --------------------------------------------------
  // ANY
  //
  // Match when at least one nested condition matches.
  // --------------------------------------------------

  if (Array.isArray(condition.any)) {
    return condition.any.some((item) =>
      matchesCondition(item, answersMap),
    )
  }

  // --------------------------------------------------
  // ALL
  //
  // Match only when every nested condition matches.
  // --------------------------------------------------

  if (Array.isArray(condition.all)) {
    return condition.all.every((item) =>
      matchesCondition(item, answersMap),
    )
  }

  // --------------------------------------------------
  // SIMPLE CONDITION
  // --------------------------------------------------

  const {
    field,
    equals,
  } = condition

  return Array.isArray(equals)
    ? equals.includes(answersMap[field])
    : answersMap[field] === equals
}

export const shouldShowStep = ({
  step,
  answersMap,
}) => {
  if (!step?.showWhen) return true

  return matchesCondition(step.showWhen, answersMap)
}

export const findNextVisibleQuestion = ({
  questions,
  fromIndex,
  answersMap,
  isQuestionGated,
}) => {
  let nextIndex = fromIndex

  while (nextIndex < questions.length) {
    const step = questions[nextIndex]

    const isVisible = shouldShowStep({
      step,
      answersMap,
    })

    const isGated =
      isQuestionGated(nextIndex)

    if (isVisible && !isGated) {
      return nextIndex
    }

    nextIndex += 1
  }

  return null
}

export const isStepGatedByPlan = ({
  step,
  questionGates,
  canAccess,
}) => {
  if (!step) return false

  const requiredFeature =
    questionGates[step.id]

  if (!requiredFeature) return false

  return !canAccess(requiredFeature)
}